// extracted by mini-css-extract-plugin
module.exports = {"descriptionBox":"PageDescription_descriptionBox__qjsA0","title":"PageDescription_title__2x15V"};